import { useMemo, useState } from "react";
import { JsonCollapsibleContent } from "./json-viewer/JsonCollapsibleContent";
import { JsonTypeDisplay } from "./json-viewer/JsonTypeDisplay";
import { JsonViewerHeader } from "./json-viewer/JsonViewerHeader";

interface JsonViewerProps {
  data: unknown;
  title?: string;
  defaultExpanded?: boolean;
  maxInlineSize?: number;
  showCopyButton?: boolean;
  showToggleRaw?: boolean;
  className?: string;
}

export function JsonViewer({
  data,
  title,
  defaultExpanded = false,
  maxInlineSize = 100,
  showCopyButton = true,
  showToggleRaw = true,
  className,
}: JsonViewerProps) {
  const [showRaw, setShowRaw] = useState(false);

  // Check if this is a primitive value that doesn't need full JSON rendering
  const isPrimitive = typeof data !== "object" || data === null;

  const jsonString = useMemo(() => {
    try {
      return JSON.stringify(data, null, 2);
    } catch {
      return "[Invalid JSON Object]";
    }
  }, [data]);

  // const isLarge = jsonString.length > maxInlineSize;

  // For primitive values, render inline without card wrapper
  if (isPrimitive) {
    return <JsonTypeDisplay value={data} />;
  }

  // console.log("debug", {
  //   isLarge,
  //   title,
  //   jsonString,
  // });

  // // For small objects that don't need expansion
  // if (!isLarge && !title) {
  //   return (
  //     <span className="font-mono text-foreground">
  //       {showRaw ? JSON.stringify(data) : jsonString}
  //     </span>
  //   );
  // }

  return (
    <div className={className}>
      {title && (
        <JsonViewerHeader
          title={title}
          jsonString={jsonString}
          showRaw={showRaw}
          onToggleRaw={setShowRaw}
          showCopyButton={showCopyButton}
          showToggleRaw={showToggleRaw}
        />
      )}

      <JsonCollapsibleContent
        data={data}
        showRaw={showRaw}
        maxInlineSize={maxInlineSize}
        defaultExpanded={defaultExpanded}
      />
    </div>
  );
}
